import CInput from '@components/UI/input/CInput';
import CRadio from '@components/UI/radio/CRadio';
import CSelect from '@components/UI/select/CSelect';
import type { TreeSelectProps } from 'antd';
import {
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Checkbox,
  Button,
  notification,
  TreeSelect,
} from 'antd';
import { useEffect, useState } from 'react';
import api from '@modules/Quotation/services';
import CustomLoader from '@components/UI/CustomLoader/CustomLoader';
import { checkDisabledField } from '@modules/Quotation/Helpers/checkDisabledField';
import useQuotation from '@modules/Quotation/hooks/useQuotation';
import CDatePicker from '@components/UI/datepicker/CDatePicker';
import { TreeNode } from 'antd/es/tree-select';
import QuotationTreeSelect from '@modules/Quotation/MainQuotation/QuotationTreeSelect';
import DateMask from '@modules/Edo/DateMask';
import dayjs from 'dayjs';

const { Option } = Select;
const ObjectCardAdditionalDynamic = ({
  agrIsn,
  objAttributesList,
  userForeignId,
  additionalObjAttributesForm,
  selectedObj,
  dicti,
  objAttrData,
  openTypeId,
  productIsn,
}) => {
  const [loading, setLoading] = useState(false);
  const [dictiList, setDictiList] = useState({});
  const { stateDateQuotation } = useQuotation();

  const saveObjAttr = async () => {
    additionalObjAttributesForm.validateFields().then(async (value) => {
      setLoading(true);
      const all = Object.keys(additionalObjAttributesForm.getFieldsValue())
        .map((key) => additionalObjAttributesForm.getFieldsValue()[key])
        .map((item) => {
          if (item.value !== undefined) {
            return {
              ...item,
              value: item.value ? '1' : '0',
              fid_obj: selectedObj.fid_obj,
              user_isn: userForeignId,
              obj_isn: selectedObj.isn,
            };
          } else {
            return {
              ...item,
              fid_obj: selectedObj.fid_obj,
              user_isn: userForeignId,
              obj_isn: selectedObj.isn,
            };
          }
        });
      all.map(async (item) => {
        await api.saveQuotation.attribute_obj_save({
          agr_obj_attributes: item,
        });
      });
      notification.success({
        message: 'Данные успешно сохранены',
      });
      setLoading(false);
    });
  };
  useEffect(() => {
    if (agrIsn) {
      Object.keys(additionalObjAttributesForm.getFieldsValue()).map((key) => {
        additionalObjAttributesForm.setFieldsValue({
          [key]: {
            ...additionalObjAttributesForm.getFieldsValue()[key],
            agr_isn: agrIsn,
          },
        });
      });

      // additionalObjAttributesForm.setFieldValue('agr_isn', agrIsn);
    }
  }, [agrIsn]);
  useEffect(() => {
    if (objAttrData && objAttrData.attributes_object_insurer.length) {
      objAttrData.attributes_object_insurer.map((item) => {
        if (Number(item.obj_isn) === Number(selectedObj.isn)) {
          switch (item.attr_isn_code) {
            case 'DICTI':
              additionalObjAttributesForm.setFieldsValue({
                [item.attr_isn]: {
                  ...item,
                  val_n: item.val_n ? Number(item.val_n) : null,
                  agr_isn: agrIsn,
                },
              });
              break;
            case 'DATE':
              additionalObjAttributesForm.setFieldsValue({
                [item.attr_isn]: {
                  ...item,
                  val_d: item.value ? dayjs(item.value) : null,
                  agr_isn: agrIsn,
                },
              });
              break;
            case 'CHECKBOX':
              additionalObjAttributesForm.setFieldsValue({
                [item.attr_isn]: {
                  ...item,
                  agr_isn: agrIsn,
                  value: item.val_c === 1,
                },
              });
              break;
            default:
              additionalObjAttributesForm.setFieldsValue({
                [item.attr_isn]: { ...item, agr_isn: agrIsn },
              });
          }
        }
      });
    }
  }, [objAttrData]);
  const getDictis = async (fileds) => {
    if (fileds.length && fileds.length > 0) {
      let dictiData = await Promise.all(
        fileds.map(async (item) => {
          const { data } = await api.auto.getDictiByIsn({
            isn: item.attr_isn,
            obj_isn: agrIsn,
          });
          if (item.attr_type === 'DICTI') {
            return { ...data.data, attr_isn: item.attr_isn };
          } else {
            return { children: [...data.data], attr_isn: item.attr_isn };
          }
        })
      );
      const changeToObject = Object.fromEntries(
        dictiData.map((item) => [item.attr_isn, item])
      );
      setDictiList(changeToObject);
    }
  };
  useEffect(() => {
    if (objAttributesList.additional) {
      getDictis(
        objAttributesList.additional.filter(
          (data) => data.attr_type === 'DICTI' || data.attr_type === 'SQL'
        )
      );
    }
  }, [objAttributesList]);
  DateMask();

  return (
    <CustomLoader spinning={loading}>
      <Form
        className="c-form"
        layout="vertical"
        name="objAttributes"
        form={additionalObjAttributesForm}
      >
        <Row gutter={6}>
          {objAttributesList.additional
            .filter((elem) => {
              if (Number(productIsn) === 6065101) {
                if (
                  (elem.attr_isn !== 2730571 &&
                    JSON.parse(elem.params).includes(
                      Number(selectedObj.classisn)
                    ) &&
                    JSON.parse(elem.params).includes(
                      Number(selectedObj.subclassisn)
                    )) ||
                  (JSON.parse(elem.params).includes(
                    Number(selectedObj.class_isn)
                  ) &&
                    JSON.parse(elem.params).includes(
                      Number(selectedObj.sub_class_isn)
                    ))
                ) {
                  return elem;
                }
              } else {
                if (
                  (JSON.parse(elem.params).includes(
                    Number(selectedObj.classisn)
                  ) &&
                    JSON.parse(elem.params).includes(
                      Number(selectedObj.subclassisn)
                    )) ||
                  (JSON.parse(elem.params).includes(
                    Number(selectedObj.class_isn)
                  ) &&
                    JSON.parse(elem.params).includes(
                      Number(selectedObj.sub_class_isn)
                    ))
                ) {
                  return elem;
                }
              }
            })
            ?.map((item) => {
              if (item.active_mycent) {
                switch (item.attr_type) {
                  case 'DICTI':
                  case 'SQL':
                    return (
                      <Col span={8} key={`${item.attr_isn}-${item.attr_name}`}>
                        <Form.Item
                          name={[item.attr_isn, 'agr_isn']}
                          initialValue={`${agrIsn}`}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'class_isn']}
                          initialValue={'220596'}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'attr_isn']}
                          initialValue={item.attr_isn}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'user_isn']}
                          initialValue={userForeignId}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'val_n']}
                          label={item.attr_name}
                          rules={[
                            {
                              required: item.required,
                              message: 'Обязательное поле',
                            },
                          ]}
                        >
                          {dictiList && dictiList[item.attr_isn]?.children ? (
                            dictiList[item.attr_isn]?.children[0]
                              ?.n_children ? (
                              <QuotationTreeSelect
                                placeholder={item.attr_name}
                                list={dictiList[item.attr_isn]?.children}
                                size="middle"
                              />
                            ) : (
                              <CSelect
                                placeholder={item.attr_name}
                                disabled={checkDisabledField(
                                  stateDateQuotation.status_isn
                                )}
                              >
                                {dictiList[item.attr_isn]?.children?.map(
                                  (dictiItem) => (
                                    <Option
                                      value={
                                        dictiItem.foreign_id
                                          ? dictiItem.foreign_id
                                          : dictiItem.isn
                                      }
                                      key={
                                        dictiItem.foreign_id
                                          ? dictiItem.foreign_id
                                          : dictiItem.isn
                                      }
                                    >
                                      {dictiItem.full_name}
                                    </Option>
                                  )
                                )}
                              </CSelect>
                            )
                          ) : (
                            <CSelect
                              placeholder={item.attr_name}
                              disabled={checkDisabledField(
                                stateDateQuotation.status_isn
                              )}
                            >
                              {dictiList &&
                                dictiList[item.attr_isn]?.map((dictiItem) => (
                                  <Option
                                    value={
                                      dictiItem.foreign_id
                                        ? dictiItem.foreign_id
                                        : dictiItem.isn
                                    }
                                    key={
                                      dictiItem.foreign_id
                                        ? dictiItem.foreign_id
                                        : dictiItem.isn
                                    }
                                  >
                                    {dictiItem.full_name}
                                  </Option>
                                ))}
                            </CSelect>
                          )}
                        </Form.Item>
                      </Col>
                    );
                  case 'NUMBER':
                  case 'INTEGER':
                  case 'FLOAT': {
                    return (openTypeId &&
                      item.attr_isn === 517761 &&
                      openTypeId === 2118) ||
                      (openTypeId &&
                        item.attr_isn === 517761 &&
                        openTypeId === 2119) ||
                      (openTypeId &&
                        item.attr_isn === 517761 &&
                        openTypeId === 2117) ? null : (
                      <Col span={8} key={`${item.attr_isn}-${item.attr_name}`}>
                        <Form.Item
                          name={[item.attr_isn, 'fid_obj']}
                          // initialValue={selectedCar.fid}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'agr_isn']}
                          initialValue={`${agrIsn}`}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'class_isn']}
                          initialValue={'220596'}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'attr_isn']}
                          initialValue={item.attr_isn}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'user_isn']}
                          initialValue={userForeignId}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'val_n']}
                          label={item.attr_name}
                          rules={[
                            {
                              required: item.required,
                              message: 'Обязательное поле',
                            },
                          ]}
                        >
                          <CInput
                            placeholder={item.attr_name}
                            className={
                              item.attr_isn === 475611 ? 'numericMask' : null
                            }
                            disabled={
                              checkDisabledField(
                                stateDateQuotation.status_isn
                              ) || item.attr_isn === 2668771
                            }
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                  case 'CHECKBOX': {
                    return (
                      <Col span={8} key={`${item.attr_isn}-${item.attr_name}`}>
                        <Form.Item
                          name={[item.attr_isn, 'fid_obj']}
                          // initialValue={selectedCar.fid}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'obj_isn']}
                          // initialValue={selectedCar.fid}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'agr_isn']}
                          initialValue={`${agrIsn}`}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'class_isn']}
                          initialValue={'220596'}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'attr_isn']}
                          initialValue={item.attr_isn}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'user_isn']}
                          initialValue={userForeignId}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'value']}
                          valuePropName="checked"
                          rules={[
                            {
                              required: item.required,
                              message: 'Обязательное поле',
                            },
                          ]}
                        >
                          <Checkbox
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          >
                            {item.attr_name}
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    );
                  }
                  case 'DOCS':
                  case 'TEXT': {
                    return (openTypeId &&
                      item.attr_isn === 517721 &&
                      openTypeId === 2118) ||
                      (openTypeId &&
                        item.attr_isn === 517741 &&
                        openTypeId === 2117) ? null : (
                      <Col span={8} key={`${item.attr_isn}-${item.attr_name}`}>
                        <Form.Item
                          name={[item.attr_isn, 'fid_obj']}
                          // initialValue={selectedCar.fid}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'agr_isn']}
                          initialValue={`${agrIsn}`}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'class_isn']}
                          initialValue={'220596'}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'attr_isn']}
                          initialValue={item.attr_isn}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'user_isn']}
                          initialValue={userForeignId}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'val_c']}
                          label={item.attr_name}
                          rules={[
                            {
                              required: item.required,
                              message: 'Обязательное поле',
                            },
                          ]}
                        >
                          <CInput
                            placeholder={item.attr_name}
                            disabled={
                              checkDisabledField(
                                stateDateQuotation.status_isn
                              ) || item.attr_isn === 2668771
                            }
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                  case 'DATE': {
                    return openTypeId &&
                      (item.attr_isn === 517731 || item.attr_isn === 517751) &&
                      openTypeId === 2118 ? null : (
                      <Col span={8} key={`${item.attr_isn}-${item.attr_name}`}>
                        <Form.Item
                          name={[item.attr_isn, 'fid_obj']}
                          // initialValue={selectedCar.fid}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'agr_isn']}
                          initialValue={`${agrIsn}`}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'class_isn']}
                          initialValue={'220596'}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'attr_isn']}
                          initialValue={item.attr_isn}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'user_isn']}
                          initialValue={userForeignId}
                          hidden
                          noStyle
                        >
                          <CInput
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[item.attr_isn, 'val_d']}
                          label={item.attr_name}
                          rules={[
                            {
                              required: item.required,
                              message: 'Обязательное поле',
                            },
                          ]}
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            format={'DD.MM.YYYY'}
                            placeholder={item.attr_name}
                            className="dateMask"
                            // size="middle"
                            disabled={checkDisabledField(
                              stateDateQuotation.status_isn
                            )}
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                }
              }
            })}
        </Row>
        <Col span={24}>
          <Button
            type="primary"
            style={{ width: '100%' }}
            onClick={saveObjAttr}
          >
            Сохранить
          </Button>
        </Col>
      </Form>
    </CustomLoader>
  );
};
export default ObjectCardAdditionalDynamic;
